module.exports = __webpack_public_path__ + "media/images/woo2-56017a51f2beec405fa5884c2c98a4d9.png";